module.exports = __webpack_public_path__ + "media/images/icon_coins-e7855c0f90dfb904428367a2e5d612d6.svg";